import { PublishableService } from '@deltasierra/integrations-integration-types';
import { ClubReadyPublishedArtifactMeta, InstagramPublishedArtifactMeta } from '../integration';
import { PublishedArtifact } from './PublishedArtifact';

export type PublishedArtifactMeta = ClubReadyPublishedArtifactMeta | InstagramPublishedArtifactMeta;

interface ServiceToMetaMap {
    clubReady: ClubReadyPublishedArtifactMeta;
    instagram: InstagramPublishedArtifactMeta;
}
export type PublishableServiceToPublishedArtifactMeta<T extends PublishableService> = T extends keyof ServiceToMetaMap
    ? ServiceToMetaMap[T]
    : unknown;

export function toPublishedArtifactWithMeta<
    T extends PublishableService,
    P extends PublishedArtifact,
    R extends Omit<P, 'meta'> & {
        channel: T;
        meta: PublishableServiceToPublishedArtifactMeta<T> | null;
    },
>(serviceName: T, publishedArtifact: P): R {
    if (serviceName !== publishedArtifact.channel) {
        throw new Error('Invalid service name. Please check the name before converting the artifact.');
    }
    return publishedArtifact as unknown as R;
}
